export default __webpack_public_path__ + "static/media/drugstore.6fc2dfd0.svg";